var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4465 0.815681C15.8023 0.459877 16.3792 0.459877 16.735 0.815681L18.5204 2.60103L20.3057 0.815701C20.6615 0.459897 21.2384 0.459897 21.5942 0.8157C21.95 1.1715 21.95 1.74838 21.5942 2.10418L19.8088 3.88951L21.5942 5.67482C21.95 6.03062 21.95 6.60749 21.5942 6.9633C21.2384 7.3191 20.6615 7.3191 20.3057 6.9633L18.5204 5.17799L16.735 6.96332C16.3792 7.31912 15.8024 7.31912 15.4466 6.96332C15.0908 6.60751 15.0908 6.03064 15.4466 5.67484L17.2319 3.88951L15.4465 2.10416C15.0907 1.74836 15.0907 1.17148 15.4465 0.815681Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5519 14.2741L14.9987 14.8566C14.9987 14.8566 13.6835 16.2412 10.0938 12.4619C6.50411 8.68261 7.81923 7.29804 7.81923 7.29804L8.16765 6.93122C9.02596 6.02757 9.10688 4.57678 8.35804 3.51764L6.8262 1.35108C5.89935 0.0401866 4.10836 -0.132983 3.04601 0.985465L1.13928 2.9929C0.612522 3.54747 0.259532 4.26638 0.302336 5.06387C0.411846 7.10413 1.28368 11.4939 6.14848 16.6156C11.3074 22.047 16.148 22.2628 18.1274 22.0675C18.7535 22.0057 19.298 21.668 19.7368 21.2061L21.4625 19.3893C22.6273 18.1629 22.2989 16.0604 20.8085 15.2026L18.4877 13.8667C17.509 13.3034 16.3168 13.4689 15.5519 14.2741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.6149c224c85270641576b3bba6914757.svg";
export { ForwardRef as ReactComponent };